import type { FaireProductEntity } from "../../entity_types/product";

export const p_bffjnnw2gz: FaireProductEntity = {
  token: "p_bffjnnw2gz",
  type: "product",
  name: "Quilt Bezel Dangles",
  brandToken: "b_h93v6v8mbm",
  brandName: "Aurora Boheme",
  imageUrl:
    "https://cdn.faire.com/fastly/bef36ba79c7b86ebcaaecbb64094330eb6f3ae92ef9442152e2e8f7b45ca2578.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/433a5be6958c59b29dde9c547b0258027032f5675ceac16fae9d6b2aba3c3f03.jpeg",
  ],
  priceDollars: 20.79,
  description: "",
  tags: [],
  msrpDollars: 41.57,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:24.744Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
